import React from 'react';
import { useTranslation } from 'react-i18next';
import { FormHelperText, TextField } from '@material-ui/core';

export const renderTextField = ({ input, label, meta: { touched, error }, ...custom }) => {
    const { t } = useTranslation();

    // If error is a known translation key, translate it here
    const translatedError = touched && error ? t(error) : '';

    return (
        <div>
            <TextField
                label={label}
                error={!!(error && touched)}
                {...input}
                {...custom}
            />
            <FormHelperText error={!!(error && touched)}>
                {translatedError}
            </FormHelperText>
        </div>
    );
};


//import React from 'react';
//import { FormHelperText, TextField } from '@material-ui/core';

//export const renderTextField = ({ input, label, meta: { touched, error }, ...custom }) => (
//        <div>
//            <TextField
//                label={label}
//                error={error && touched}
//                {...input}
//                {...custom}
//            />
//            <FormHelperText error={error && touched}>{touched && error}</FormHelperText>
//        </div>
//)